export { default } from './IconCustom';
